import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

export type TMediaGridSkeletonProps = {
  count?: number;
  columns?: { xs: number; sm: number; md: number; lg?: number };
};

export function MediaGridSkeleton(param: TMediaGridSkeletonProps) {
  const { count = 18, columns = { xs: 2, sm: 3, md: 4 } } = param;

  return (
    <Box sx={{ borderRadius: 1 }}>
      <Grid container spacing={1.5} mt={0}>
        {Array.from({ length: count }).map((_, i) => (
          // oxlint-disable-next-line react/no-array-index-key
          <Grid item key={i} xs={columns.xs} sm={columns.sm} md={columns.md} {...(columns.lg && { lg: columns.lg })}>
            <Skeleton variant="rectangular" sx={{ height: 232, width: '100%', borderRadius: 2 }} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
